//
//
//
//
//
//
//
//
//

export default {
    id: 44,
    version: '3.8.25',
    date: '2024-06-23',
    notify: true,
}
